<template>
  <div class="lang-selector ">


    <v-btn-toggle v-model="selectedLang" class="lang-selector">
      <v-btn
        v-for="btn in langList"
        :value="btn.code"
        round
      >
        {{btn.name}}
      </v-btn>
    </v-btn-toggle>
    <v-btn flat @click="dialog = true" color="primary">
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title>
          Add new language
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="newLang"
            :items="langIso"
            item-text="name"
            class=""
            return-object
            outline
            solo
            label="Search Languages"
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="d-block text-xs-right">
          <v-btn @click="addNewLang" color="primary" :disabled="!newLang.code">Add language</v-btn>
          <v-btn flat @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import langIso from "../../utils/lang-iso";
  export default {
    name: "langSelector",
    props: {
      value: {
        type: String,
        default: ()=> {
          return ''
        }
      },
      langList: {
        type:Array,
        default: ()=> {
          return [
            {
              code: 'en_US',
              name: 'English'
            }
          ]
        }
      }
    },
    data () {
      return {
        langIso,
        newLang: {},
        selectedLang: '',
        dialog: false
      }
    },
    mounted() {
      this.selectedLang  = this.value
    },
    methods: {
      addNewLang () {
        this.$emit('addNewLang', this.newLang)
        this.langList.push(this.newLang)
        this.dialog = false
        this.selectedLang = this.newLang.code
      }
    },
    watch: {
      selectedLang () {
        this.$emit('input',this.selectedLang)
      }
    }
  }
</script>

<style scoped>
  .v-btn-toggle .v-btn:first-child , .v-btn-toggle .v-btn:last-child , .v-btn-toggle .v-btn{
    border-radius: 8px !important;
    margin-right: 8px;
  }


</style>
